import React, { Component } from 'react';
import axios from 'axios/index';

import GoalListItem from '../../components/GoalListItem/GoalListItem';

class GoalList extends Component {

	state = {
		goals: [],
		myId: 0
	};

	sortZA = () => {
		const updatedGoalList = [...this.state.goals];
		updatedGoalList.sort((goal1, goal2) => {
			if (goal1.goal.toUpperCase() > goal2.goal.toUpperCase()) return -1;
			if (goal1.goal.toUpperCase() < goal2.goal.toUpperCase()) return 1;
			return 0;
		});
		this.setState({
			goals: updatedGoalList
		})
	};

	componentDidMount() {
		console.log('in goallist cdm');
		axios.get('/api/accounts/myId')
			.then(res => {
				this.setState({myId: res.data})
			})
			.then(() => {
				axios.get('/api/accounts')
					.then(response => {
						this.setState({
							goals: response.data
						})
					})
					.catch(error => {
						console.log(error.response);
					});
			})
	}

	render() {

		let goalList = this.state.goals.map(account => {
			return (
				<GoalListItem
					key={account.id}
					account={account}
					id={account.id}
					myId={this.state.myId}
				/>
			)
		});
		return (
			<div className="card-list-item">
	            <span onClick={this.sortZA}>
                    <img
                        style={{
	                        width: 33,
	                        cursor: 'pointer',
	                        position: 'absolute',
	                        left: '49%',
	                        top: 91,
	                        backgroundColor: '#ffffff1a',
	                        padding: 4
                        }}
                        src="https://cdn.pixabay.com/photo/2012/04/11/11/17/sort-27489_960_720.png"
                        alt="a-z"
                    />
                </span>
				{goalList}
			</div>
		)
	}
	;

}

export default GoalList;



// WEBPACK FOOTER //
// ./src/containers/GoalList/GoalList.js